/**
 * Replaces non-breaking spaces (&nbsp;) with regular spaces
 * so that text wraps properly at word boundaries.
 */
export const sanitizeHtml = (html: string): string => {
    return html.replace(/&nbsp;/g, ' ').replace(/\u00A0/g, ' ');
};
